export const chargesInput = [
    {
        id:"companyIntroduction",
        label: "Company Introduction",
        type: "text",
        placeholder:"$100",
    },
    {
        id:"selfIntroduction",
        label: "Self Introduction",
        type: "text",
        placeholder:"$100",
    },
    {
        id:"leaveApproval",
        label: "Leave Approval",
        type: "text",
        placeholder:"$100",
    },
    {
        id:"employmentLetter",
        label: "Employment Letter",
        type: "text",
        placeholder:"$100",
    },
    {
        id:"visaProcessingFee",
        label: "Visa Processing Fee",
        type: "text",
        placeholder:"$400",
    },

   
];


export const applicantInput = [
    {
        id:"username",
        label: "Username",
        type: "text",
        placeholder:"Chukwuma2022",
    },
    {
        id:"fullname",
        label: "Fullname",
        type: "text",
        placeholder:"Chukwuma Johnson",
    },
    {
        id:"email",
        label: "Email",
        type: "email",
        placeholder:"Chukwuma_Johnson@gmail.com",
    },
    {
        id:"telephone",
        label: "telePhone",
        type: "text",
        placeholder:"+234 8139 444 402",
    },
    {
        id:"password",
        label: "Password",
        type: "password",
    },
    {
        id:"address",
        label: "Address",
        type: "text",
        placeholder:"6 Abayomi st. Awka",
    },
    {
        id:"state",
        label: "State",
        type: "text",
        placeholder:"Anambra",
    },

];



export const notificationInput = [
    {
        id:"title",
        label: "Title",
        type: "text",
        placeholder:"Food name",
    },
    {
        id:"description",
        label: "Description",
        type: "text",
        placeholder:"Description",
    },
    {
        id:"category",
        label: "category",
        type: "text",
        placeholder:"Fast Food",
    },
    {
        id:"price",
        label: "Price",
        type: "text",
        placeholder:"2400",
    },
    {
        id:"stock",
        label: "Stock",
        type: "text",
        placeholder:"available",
    },
  
];

export const settingsInput = [
    {
        id:"fullname",
        label: "Fullname",
        type: "text",
        placeholder:"Full name",
    },
    {
        id:"telephone",
        label: "Telephone",
        type: "text",
        placeholder:"telephone",
    },
    {
        id:"email",
        label: "Email",
        type: "text",
        placeholder:"Email Address",
    },
    {
        id:"status",
        label: "Status",
        type: "text",
        placeholder:"active",
    },
    {
        id:"password",
        label: "Password",
        type: "password",
        placeholder:"password",
    }
    ,
    {
        id:"confirmpassword",
        label: "Confirm Password",
        type: "confirmpassword",
        placeholder:"confirm password",
    }
    ,
    {
        id:"role",
        label: "Role",
        type: "text",
        placeholder:"admin",
    }
  
];

export const messagesInput = [
    {
        id:"fullname",
        label: "Fullname",
        type: "text",
        placeholder:"Full name",
    },
  
    {
        id:"message",
        label: "Message",
        type: "text",
        placeholder:"message",
    },
  
    {
        id:"icon",
        label: "icon",
        type: "text",
        placeholder:"icon",
    }
  
];




















// export const staffInput = [
//     {
//         id:"firstname",
//         label: "Firstname",
//         type: "text",
//         placeholder:"David",
//     },
//     {
//         id:"lastname",
//         label: "Lastname",
//         type: "text",
//         placeholder:"Johnson",
//     },
//     {
//         id:"email",
//         label: "Email",
//         type: "email",
//         placeholder:"abiolajohnson@gmail.com",
//     },
//     {
//         id:"telephone",
//         label: "telePhone",
//         type: "text",
//         placeholder:"+234 8139 444 402",
//     },{
//         id:"role",
//         label: "Staff Role",
//         type: "text",
//         placeholder:"Business Analyst",
//     },
   
//     {
//         id:"address",
//         label: "Address",
//         type: "text",
//         placeholder:"6 Abayomi st. Ikeja",
//     },
//       {
//         id:"gender",
//         label: "Gender",
//         type: "text",
//         placeholder:"Male",
//     },
//     {
//         id:"dob",
//         label: "Date of Birth",
//         type: "text",
//         placeholder:"13/05/1995"
//     },
//     {
//         id:"state",
//         label: "State",
//         type: "text",
//         placeholder:"Lagos",
//     },

// ];

// export const agentInput = [
//     {
//         id:"firstname",
//         label: "Firstname",
//         type: "text",
//         placeholder:"David",
//     },
//     {
//         id:"lastname",
//         label: "Lastname",
//         type: "text",
//         placeholder:"Johnson",
//     },
//     {
//         id:"email",
//         label: "Email",
//         type: "email",
//         placeholder:"Chukwuma_Johnson@gmail.com",
//     },
//     {
//         id:"telephone",
//         label: "TelePhone",
//         type: "text",
//         placeholder:"+234 8139 444 402",
//     },{
//         id:"role",
//         label: "Company Name",
//         type: "text",
//         placeholder:"Company Name",
//     },
   
//     {
//         id:"address",
//         label: "Address",
//         type: "text",
//         placeholder:"6 Abayomi st. Awka",
//     },
    
//     {
//         id:"state",
//         label: "State",
//         type: "text",
//         placeholder:"Anambra",
//     },

// ];

// export const riderInput = [
//     {
//         id:"username",
//         label: "Username",
//         type: "text",
//         placeholder:"Chukwuma2022",
//     },
//     {
//         id:"fullname",
//         label: "Fullname",
//         type: "text",
//         placeholder:"Chukwuma Johnson",
//     },
//     {
//         id:"email",
//         label: "Email",
//         type: "email",
//         placeholder:"Chukwuma_Johnson@gmail.com",
//     },
//     {
//         id:"telephone",
//         label: "telePhone",
//         type: "text",
//         placeholder:"+234 8139 444 402",
//     },
//     {
//         id:"password",
//         label: "Password",
//         type: "password",
//     },
//     {
//         id:"address",
//         label: "Address",
//         type: "text",
//         placeholder:"6 Abayomi st. Awka",
//     },
//     {
//         id:"state",
//         label: "State",
//         type: "text",
//         placeholder:"Anambra",
//     },

// ];

// export const dispatchInput = [
//     {
//         id:"title",
//         label: "Title",
//         type: "text",
//         placeholder:"Food name",
//     },
//     {
//         id:"description",
//         label: "Description",
//         type: "text",
//         placeholder:"Description",
//     },
//     {
//         id:"category",
//         label: "category",
//         type: "text",
//         placeholder:"Fast Food",
//     },
//     {
//         id:"fare",
//         label: "Fare",
//         type: parseInt("number"),
//         placeholder:"2000",
//     },
//     {
//         id:"destination",
//         label: "Destination",
//         type: "text",
//         placeholder:"available",
//     },
  
// ];

// export const driversInput = [
//     {
//         id:"firstname",
//         label: "First Name",
//         type: "text",
//         placeholder:"Driver's First Name",
//     },
//     {
//         id:"Lastname",
//         label: "Last Name",
//         type: "text",
//         placeholder:"Drivers Last name",
//     },
//     {
//         id:"telephone",
//         label: "Telephone",
//         type: "text",
//         placeholder:"Drivers Telephone Number",
//     },
//     {
//         id:"email",
//         label: "Email",
//         type: "email",
//         placeholder:"Email",
//     },
//     {
//         id:"address",
//         label: "Drivers Address",
//         type: "text",
//         placeholder:"Address",
//     },
//     {
//         id:"nextofkin",
//         label: "Next of Kin",
//         type: "text",
//         placeholder:"Next of Kin",
//     },
//     {
//         id:"nextofkinphonenumber",
//         label: "Next of Kin Telephone",
//         type: "text",
//         placeholder:"Telephone",
//     },
//     {
//         id:"platenumber",
//         label: "Bike Plate Number",
//         type: "text",
//         placeholder:"Plate Number",
//     }
    
// ];

// export const notificationInput = [
//     {
//         id:"title",
//         label: "Notification Title",
//         type: "text",
//         placeholder:" Our new offers",
//     },
//     {
//         id:"description",
//         label: "Description",
//         type: "text",
//         placeholder:"Description",
//     },
//     {
//         id:"category",
//         label: "category",
//         type: "text",
//         placeholder:"Fast Food",
//     },
//     {
//         id:"type",
//         label: "notification type",
//         type: "text",
//         placeholder:"details",
//     },
//     // {
//     //     id:"",
//     //     label: "Stock",
//     //     type: "text",
//     //     placeholder:"available",
//     // },
  
// ];

// export const settingsInput = [
//     {
//         id:"fullname",
//         label: "fullname",
//         type: "text",
//         placeholder:"Full name",
//     },
//     {
//         id:"telephone",
//         label: "Telephone",
//         type: "text",
//         placeholder:"telephone",
//     },
//     {
//         id:"email",
//         label: "email",
//         type: "text",
//         placeholder:"Email Address",
//     },
//     {
//         id:"status",
//         label: "Status",
//         type: "text",
//         placeholder:"Status",
//     },
//     {
//         id:"password",
//         label: "Password",
//         type: "password",
//         placeholder:"password",
//     }
//     ,
//     {
//         id:"confirmpassword",
//         label: "Confirm Password",
//         type: "confirmpassword",
//         placeholder:"confirm password",
//     }
//     ,
//     {
//         id:"role",
//         label: "Role",
//         type: "text",
//         placeholder:"role",
//     }
  
// ];

// export const fareRateInput = [
  
//     {
//         id:"typename",
//         label: "Type Name",
//         type: "text",
//         placeholder:"type name",
//     },

  
//     {
//         id:"basefare",
//         label: "Base Fare",
//         type: "number",
//         placeholder:" N600 ",
//     },
//     {
//         id:"distanceRate",
//         label: "Distance Rate",
//         type: "number",
//         placeholder:"N100",
//     },
//     {
//         id:"timeRate",
//         label: "Time Rate",
//         type: "number",
//         placeholder:"N200",
//     }
 
   
  
// ];